import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';
import { usdAmount } from 'libs/ui/src/lib/components/borrowerBaseballCard/utils';

export enum ClosingLoansSubTab {
  INSURANCE,
  HUD,
  LOAN_DOCS,
  ACH,
  ENTITY_DOCS,
}

export const CLOSING_LOANS_SUB_TABS = [
  { value: ClosingLoansSubTab.INSURANCE, label: 'Insurance' },
  { value: ClosingLoansSubTab.HUD, label: 'HUD' },
  { value: ClosingLoansSubTab.LOAN_DOCS, label: 'Loan Docs' },
  { value: ClosingLoansSubTab.ACH, label: 'ACH' },
  { value: ClosingLoansSubTab.ENTITY_DOCS, label: 'Entity Docs' },
];

// Values of v_closing_loans_dashboard.closing_task_type
export const CLOSING_TASK_TYPE_BY_SUB_TAB: Record<ClosingLoansSubTab, string> = {
  [ClosingLoansSubTab.INSURANCE]: 'INSURANCE',
  [ClosingLoansSubTab.HUD]: 'HUD',
  [ClosingLoansSubTab.LOAN_DOCS]: 'LOAN_DOCS',
  [ClosingLoansSubTab.ACH]: 'ACH',
  [ClosingLoansSubTab.ENTITY_DOCS]: 'ENTITY_DOCS',
};

export const DEFAULT_SORT_MODEL = [{ colId: 'businessTimeInQueue', sort: 'desc' }];

export const closingLoansDashboardColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    width: 110,
    ...filterProps(),
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Sub Type',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'loanAmount',
    headerName: 'Loan Amount',
    valueFormatter: usdAmount,
    minWidth: 140,
    ...filterProps(),
  },
  {
    field: 'initialLoanAmount',
    headerName: 'Initial Loan Amount',
    valueFormatter: usdAmount,
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'attorney',
    headerName: 'Attorney',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender Name',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'expectedClosingDate',
    headerName: 'Expected Closing Date',
    minWidth: 170,
    ...filterProps(),
  },
  {
    field: 'assignee',
    headerName: 'Assigned To',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'businessTimeInQueue',
    headerName: 'Business Time in Queue',
    minWidth: 220,
    ...filterProps(),
  },
];
